import { Injectable } from '@angular/core';
import { Notyf } from 'notyf';
import 'notyf/notyf.min.css';

@Injectable({
  providedIn: 'root',
})
export class ToastNotifService {
  private notyf: Notyf;

  constructor() {
    this.notyf = new Notyf({
      duration: 3000,
      dismissible: true, // ✅ สำคัญ
      position: {
        x: 'center',
        y: 'top',
      },
      types: [
        {
          type: 'success',
          background: '#22c55e',
        },
        {
          type: 'error',
          background: '#ef4444',
        },
        {
          type: 'warning',
          background: '#facc15',
          icon: {
            tagName: 'i',
            className: 'material-symbols-outlined',
            text: 'report_problem',
          },
        },
      ],
    });
  }

  success(message: string) {
    this.notyf.success(message);
  }

  error(message: string) {
    this.notyf.error(message);
  }

  warning(message: string) {
    this.notyf.open({ type: 'warning', message });
  }
}
